import { styled, SxProps, Theme } from '@mui/material';

export const FilePageContentContainer = styled('div', { name: 'FilePageContentContainer' })(
	({ theme }) => ({
		// maxWidth: '65rem',
		paddingRight: theme.spacing(4),
		display: 'grid',
		gridTemplateColumns: '1fr',
		gap: theme.spacing(6),
		marginBottom: theme.spacing(8),
		[theme.breakpoints.up('lg')]: {
			gridTemplateColumns: '1fr 15rem',
		},
		[theme.breakpoints.up('xl')]: {
			gridTemplateColumns: '1fr 25rem',
		},
	})
);

export const fileDetailsSx: SxProps<Theme> = (theme) => ({
	gridRow: 'span 2',
	height: 'fit-content',
	[theme.breakpoints.down('lg')]: { display: 'none' },
});
